// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"userInfo_userInfo__2C8Y9","userLink":"userInfo_userLink__3GasV","gentle":"userInfo_gentle__A3clN"};